import { render, staticRenderFns } from "./AddMedicineReciept.vue?vue&type=template&id=17cebb1f&scoped=true"
import script from "./AddMedicineReciept.vue?vue&type=script&lang=js"
export * from "./AddMedicineReciept.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17cebb1f",
  null
  
)

export default component.exports